import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import CheckMark from '../../assets/icons/checkmark.svg';

const CheckList = ({ title, items }) => (
  <div className="checklist">
    {title && <h2>{title}</h2>}
    <ul>
      {items.map(item => (
        <li key={uuid()}>
          <CheckMark />
          <p>{item}</p>
        </li>
      ))}
    </ul>
  </div>
);

CheckList.defaultProps = {
  title: 'De voordelen van inloggen met uw telefoon',
  items: [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do',
  ],
};

CheckList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
};
export default CheckList;
